import { render, staticRenderFns } from "./ResourceInfo.vue?vue&type=template&id=5d8db4dc"
import script from "./ResourceInfo.vue?vue&type=script&lang=js"
export * from "./ResourceInfo.vue?vue&type=script&lang=js"
import style0 from "./ResourceInfo.vue?vue&type=style&index=0&id=5d8db4dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports